import Vue from 'vue';
import {DateTime} from 'luxon';

export function installFilters() {
    Vue.filter('shortDate', (value: string) => {
        return DateTime.fromISO(value, { zone: 'America/Chicago'}).toLocaleString(DateTime.DATE_SHORT);
    });
    Vue.filter('dotFormattedDate', (value: string) => {
        return DateTime.fromISO(value, { zone: 'America/Chicago'}).toFormat('MM.dd.yyyy');
    });
    Vue.filter('simpleTime', (value: string) => {
        return DateTime.fromISO(value, {zone: 'America/Chicago'}).toLocaleString(DateTime.TIME_SIMPLE);
    });
    Vue.filter('dateMedium', (value: string) : string => {
        return DateTime.fromISO(value, { zone: 'America/Chicago'}).toLocaleString(DateTime.DATE_MED);
    });
    Vue.filter('timeShortOffset', (value: string) : string => {
        return DateTime.fromISO(value, { zone: 'America/Chicago' }).toFormat('h:mm a ZZZZ')
    });
}
